module.exports = __webpack_public_path__ + "img/2004.5963da18.jpg";